import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import * as characterActions from './../../actions/characterActions';
import Hero from './../../components/Hero';
import Breadcrumb from './../../components/Breadcrumb';
import { Container, Section } from './../../styles';
import { routeCodes } from './../../routes'

class Subpage extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  };

  componentDidMount() {
    const { getCharacter, match } = this.props;
    const id = match.params.id;
    getCharacter(id);

  }

  /**
   * Empty control and return list item
   * @param {String} name 
   * @param {String} value 
   */
  renderListItem = (name, value) => {
    if (name && value) {
      return (
        <div><b>{name }:</b> { value }</div>
      )
    }
  }

  renderOrigin(name, data) {
    if (data) {
      return (<div><b>{ name }:</b> { data.name }</div>);
    }
  }

  renderEpisodes() {
    const { episodes } = this.props;

    if (episodes) {
      return (
        episodes.map((episode , key) => {
            return (<div key={ key }>{ episode.episode } - { episode.name }</div>)         
          }
        )
      )
    }

    return '';
  }

  render() {
    const { 
      name,
      image,
      status,
      species,
      gender, 
      origin, 
    } = this.props.character;

    return (
      <div>
        <Hero
          title={ name }
          subtitle="Focus on science!" 
        />
        <Section>
          <Container>
            <Breadcrumb active={ name } />
          </Container>
        </Section>
        <Section>
          <Container>
            <PageContent>
              <Figure>
                <img src={ image } alt={ name } />
              </Figure>
              <PageText>
                <h1>{ name }</h1>
                <div>
                  { this.renderListItem('Status', status ) }
                  { this.renderListItem('Species', species ) }
                  { this.renderListItem('Gender', gender ) }
                  { this.renderOrigin('Origin', origin) }
                </div>
              </PageText>
            </PageContent>
          </Container>
        </Section>
        <Section>
          <Container>
            <PageFooter>
              <div>
                <h3>Last Episodes</h3>
                <div>
                  { this.renderEpisodes() }
                </div>
              </div>
              <PageControl>
                <Link to={ routeCodes.HOME }>Back to homepage</Link>
              </PageControl>
            </PageFooter>
          </Container>
        </Section>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    character: state.characterReducer.character,
    episodes: state.characterReducer.episodes,
    loading: state.characterReducer.loading,
    isError: state.characterReducer.isError,
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(characterActions, dispatch);

export default connect(
  mapStateToProps, 
  mapDispatchToProps
)(Subpage);


const Figure = styled.figure`
  display: inline-block;
  position: relative;
  background-color: #f6f8fa;
  border: 1px solid #e1e4e8;
  padding: 5px;
  margin-bottom: 1.5rem;
  line-height: 0;
`;

const PageContent = styled.article`
  color: ##4a4a4a;
`;

const PageText = styled.div `
  h1 {
    color: #363636;
    font-size: 2rem;
    font-weight: 600;
    line-height: 1.125;
    margin-bottom: 1.5rem;
  }
`;

const PageFooter = styled.div`
  border-top: 1px solid rgba(10, 10, 10, 0.1);
  padding-top: 1.5rem;

  h3 {
    color: #363636;
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 1.125;
    margin-bottom: 1.5rem;
  }
`;

const PageControl = styled.div`
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;

  a {
    display: block;
    width: 100%;
    cursor: pointer;
    border-radius: 4px;
    justify-content: center;
    padding-bottom: calc(.775em - 1px);
    padding-top: calc(.775em - 1px);
    padding-left: .75em;
    padding-right: .75em;
    text-align: center;
    white-space: nowrap;
    background: #00d1b2;
    color: #fff;
    text-align: center;
    transition: all 0.3s ease;
  }

  a:hover {
    color: #fff;
    background: #00c4a7;
  }
`;